import React, { useContext, useEffect, useState } from "react";
import "../Style/Home.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AppLanguage } from "../context/ApplicationLanguage";
import axios from "axios";

// قائمة المنتجات مع صور مخصصة لكل لغة
const Product = [
  {
    src: {
      en: "jerusalem-en.jpg",
      ar: "jerusalem-ar.jpg",
      he: "jerusalem-he.jpg",
    },
    alt: "Jerusalem Stone Collection",
    labelKey: "product1Label",
  },
  {
    src: {
      en: "nature-en.jpg",
      ar: "nature-ar.jpg",
      he: "nature-he.jpg",
    },
    alt: "Nature Collection",
    labelKey: "product2Label",
  },
  {
    src: {
      en: "other-en.jpg",
      ar: "other-ar.jpg",
      he: "other-he.jpg",
    },
    alt: "Other Collection",
    labelKey: "product3Label",
  },
];

// صور بانر حسب اللغة
const BannerImages = {
  en: "Home-en.jpg",
  ar: "Home-ar.jpg",
  he: "Home-he.jpg",
};

const Home = () => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const appLang = useContext(AppLanguage);
  const API_BASE_URL = "https://server-alwaleedstone.onrender.com";

  useEffect(() => {
    const fetchFirstThreeProjects = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/project/firstThree?lang=${appLang.language}`
        );
        setProjects(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchFirstThreeProjects();
  }, [appLang.language]);

  return (
    <div className="home-container">
      {/* قسم البانر */}
      <section className="quarry-hero-section">
        <div className="quarry-hero-content">
          <div className="quarry-hero-image">
            <img src={BannerImages[appLang.language] || BannerImages.en} alt="Quarry" />
          </div>
          <div className="quarry-hero-text" style={{ textAlign: "center" }}>
            <h2 className="quarry-title">AlwaleedStone</h2>
            <p className="quarry-description">{t("companyDescription")}</p>
            <h3 className="catalog-heading">{t("catalogDownload")}</h3>
            <a
              href="Al-Waleed-StoneCo.Profile.pdf"
              download
              className="download-button"
            >
              {t("catalog")}
            </a>
          </div>
        </div>
      </section>

      {/* قسم الكولكشن */}
      <section className="projects-section">
        <div className="projects-header">
          <Link to="/stone-types" className="view-all-btn">
            {t("view-Our-Collection")}
          </Link>
          <h2 className="section-title">{t("Collection")}</h2>
        </div>
        <div className="projects-grid">
          {Product.map(({ src, alt, labelKey }, index) => (
            <div key={index} className="project-card">
              <img
                src={src[appLang.language] || src.en}
                alt={alt}
                className="project-image"
                loading="lazy"
              />
              <p className="project-name">{t(labelKey) || alt}</p>
            </div>
          ))}
        </div>
      </section>

      {/* قسم المشاريع */}
      <section className="projects-section">
        <div className="projects-header">
          <Link to="/projects" className="view-all-btn">
            {t("view-all-projects")}
          </Link>
          <h2 className="section-title">{t("Projects")}</h2>
        </div>
        <div className="projects-grid">
          {projects.map((item) => (
            <Link
              key={item._id}
              to={`/project/${item._id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="project-card">
                <img
                  src={item.project_image}
                  alt={item.project_name}
                  className="project-image"
                  loading="lazy"
                />
                <p className="project-name">{item.project_name}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
